import React, { memo, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { DeepReadonly } from 'utility-types';

import * as actions from './actions';
import { AccommodationOfferRoomModel, AccommodationOfferRoomTypeModel } from '../../api/interfaces';
import { ApplicationState } from '../../store/rootReducer';
import { selectRoomSelectItems } from './selectors';
import AccommodationOfferRoomTypeDetail, { AccommodationOfferRoomTypeDetailDispatchProps, AccommodationOfferRoomTypeDetailProps, AccommodationOfferRoomTypeDetailStateProps } from './accommodationOfferRoomTypeDetail';
import { RelationSelectItem } from '../../components';

type AccommodationOfferRoomCreateContainerStateProps = {

} & AccommodationOfferRoomTypeDetailStateProps;

type AccommodationOfferRoomCreateContainerDispatchProps = {
  editRoomType: typeof actions.editRoomTypeAction;
} & AccommodationOfferRoomTypeDetailDispatchProps;

type AccommodationOfferRoomCreateContainerProps = {} & AccommodationOfferRoomTypeDetailProps & AccommodationOfferRoomCreateContainerStateProps & AccommodationOfferRoomCreateContainerDispatchProps;

const createInitialValues = {
  rooms: [] as AccommodationOfferRoomModel[]
} as AccommodationOfferRoomTypeModel;

const AccommodationOfferRoomCreateContainer: React.FunctionComponent<AccommodationOfferRoomCreateContainerProps> = memo(props => {
  console.debug('AccommodationOfferRoomCreateContainer');
  const [_roomsSelectItems, _setRoomsSelectItems] = useState<RelationSelectItem[]>([]);

  const {
    errorMessage,
    requestInProgress,
    initialValues,
    modalDialog,
    modalDialogRoute,
    saveActionRequest,
    cancelActionRequest,
    loadDependenciesRequest,
    editRoomType,
    roomsSelectItems,
    rooms
  } = props;

  return (
    <React.Fragment>
      <AccommodationOfferRoomTypeDetail
        initialValues={initialValues}
        errorMessage={errorMessage}
        requestInProgress={requestInProgress}
        modalDialog={modalDialog}
        modalDialogRoute={modalDialogRoute}
        loadDependenciesRequest={loadDependenciesRequest}
        saveActionRequest={saveActionRequest}
        cancelActionRequest={cancelActionRequest}
        editRoomType={editRoomType}
        roomsSelectItems={roomsSelectItems}
        rooms={rooms}
        _roomsSelectItems={_roomsSelectItems}
        _setRoomsSelectItems={_setRoomsSelectItems}
      />
    </React.Fragment>
  );
});

const mapStateToProps = (state: ApplicationState, ownProps: any): AccommodationOfferRoomCreateContainerStateProps => {
  return {
    initialValues: createInitialValues,
    errorMessage: state.states.errorMessage,
    requestInProgress: state.states.requestInProgress,
    roomsSelectItems: selectRoomSelectItems(state, ownProps.roomTypeId, ownProps.floorNumber, []),
    rooms: state.rooms.itemList.byId
  };
};

const mapDispatchToProps = (dispatch: Dispatch): AccommodationOfferRoomCreateContainerDispatchProps => {
  return {
    ...bindActionCreators(
      {
        saveActionRequest: actions.saveRoomTypeAsync.request,
        cancelActionRequest: actions.cancelRoomTypeAsync.request,
        loadDependenciesRequest: actions.loadDependenciesAsync.request,
        editRoomType: actions.editRoomTypeAction
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccommodationOfferRoomCreateContainer);
